export default {
  table_label_empty_data: {
    en: 'No records to display',
    fr: 'Aucun enregistrement à afficher',
  },
  table_label_tooltip_add: {
    en: 'Add',
    fr: 'Ajouter',
  },
  table_label_tooltip_delete: {
    en: 'Delete',
    fr: 'Supprimer',
  },
  table_label_tooltip_edit: {
    en: 'Edit',
    fr: 'modifier',
  },
  table_label_tooltip_filter: {
    en: 'Filter',
    fr: 'Filtre',
  },
  table_label_text_delete: {
    en: 'Are you sure delete this row?',
    fr: 'Êtes-vous sûr de supprimer cette ligne?',
  },
  table_label_tooltip_cancel: {
    en: 'Cancel',
    fr: 'Annuler',
  },
  table_label_tooltip_save: {
    en: 'Save',
    fr: 'sauver',
  },
  table_label_grouping_placeholder: {
    en: 'Drag headers here to group by',
    fr: 'Faites glisser les en-têtes ici pour regrouper par',
  },
  table_label_header_actions: {
    en: 'Actions',
    fr: 'actes',
  },
  table_label_pagination_rows_select: {
    en: 'rows',
    fr: 'rangées',
  },
  table_label_pagination_rows_per_page: {
    en: 'Rows per page:',
    fr: 'Lignes par page:',
  },
  table_label_pagination_arial_first: {
    en: 'First Page',
    fr: 'Première page',
  },
  table_label_pagination_tooltip_first: {
    en: 'First Page',
    fr: 'Première page',
  },
  table_label_pagination_arial_previous: {
    en: 'Previous Page',
    fr: 'Page précédente',
  },
  table_label_pagination_tooltip_previous: {
    en: 'Previous Page',
    fr: 'Page précédente',
  },
  table_label_pagination_arial_next: {
    en: 'Next Page',
    fr: 'Page suivante',
  },
  table_label_pagination_tooltip_next: {
    en: 'Next Page',
    fr: 'Page suivante',
  },
  table_label_pagination_arial_last: {
    en: 'Last Page',
    fr: 'Dernière page',
  },
  table_label_pagination_tooltip_last: {
    en: 'Last Page',
    fr: 'Dernière page',
  },
  table_label_toolbar_add_remove_columns: {
    en: 'Add or remove columns',
    fr: 'Ajouter ou supprimer des colonnes',
  },
  table_label_toolbar_show_columns: {
    en: 'Show Columns',
    fr: 'Afficher les colonnes',
  },
  table_label_toolbar_arial_show_columns: {
    en: 'Show Columns',
    fr: 'Afficher les colonnes',
  },
  table_label_toolbar_export: {
    en: 'Export',
    fr: 'Exportation',
  },
  table_label_toolbar_arial_export: {
    en: 'Export',
    fr: 'Exportation',
  },
  table_label_toolbar_export_name: {
    en: 'Export as CSV',
    fr: 'Exporter au format CSV',
  },
  table_label_toolbar_tooltip_search: {
    en: 'Search',
    fr: 'Chercher',
  },
  table_label_toolbar_placeholder_search: {
    en: 'Search',
    fr: 'Chercher',
  },
  table_label_search_result: {
    en: 'Search Result',
    fr: 'Résultat de la recherche',
  },
  table_label_rows_selected: {
    en: '{number} row(s) selected',
    fr: '{number} ligne (s) sélectionnée (s)',
  },
};
